var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"PageLoginLayout"},[_c('div',{staticClass:"initialView"},[_c('div',{staticClass:"initialViewContent"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }